import React from 'react';
import type { Language } from '../../types';
import { getTranslation } from '../../utils/translations';
import CrescentMoonIcon from '../icons/CrescentMoonIcon';

interface FastingStartButtonProps {
    language?: Language;
    onClick: () => void;
}

const FastingStartButton: React.FC<FastingStartButtonProps> = ({ language, onClick }) => {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);

    return (
        <button
            type="button"
            onClick={onClick}
            className="flex items-center gap-1 px-1.5 sm:px-2.5 py-1 rounded-full bg-teal-50 dark:bg-teal-950/40 text-teal-700 dark:text-teal-300 border border-teal-100 dark:border-teal-900/60 hover:bg-teal-100 dark:hover:bg-teal-900/40 transition-all active:scale-95 shrink min-w-0"
            aria-label={t('fastingStart')}
        >
            <CrescentMoonIcon className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
            <span className="hidden min-[420px]:inline text-[10px] sm:text-[11px] font-bold leading-none truncate">
                {t('fastingStart')}
            </span>
        </button>
    );
};

export default FastingStartButton;
